import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import orderApi from '../../apis/order';
import { getQueryParams } from '../../helpers/params';
import { IPrintArea } from '../../interfaces/Order';
import { PaginationParamsResponse } from '../../interfaces/PaginationParamsResponse';
import { FlexContainer, PageContainer } from '../../styles/Global';
import PageHeader from '../PageHeader/PageHeader';

const PER_PAGE = 20;

// Use the antd Table directly
const StyledTable = styled(Table)`
  .drop-over-downward td {
    border-bottom: 2px dashed #1890ff !important;
  }

  .drop-over-upward td {
    border-top: 2px dashed #1890ff !important;
  }

  .ant-table-row.dragging {
    opacity: 0.5;
  }

  /* Reduce row height */
  .ant-table-tbody > tr > td {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }

  .ant-table-thead > tr > th {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
`;

// Draggable body row component
// const DraggableBodyRow = (props: any) => {
//   const { record, index, moveRow, className, style, canDrag, ...restProps } =
//     props;
//   const ref = useRef(null);

//   const [{ isOver, dropClassName }, drop] = useDrop({
//     accept: 'row',
//     canDrop: () => canDrag,
//     collect: (monitor) => {
//       const { index: dragIndex } = monitor.getItem() || {};
//       if (dragIndex === index) {
//         return {};
//       }
//       return {
//         isOver: canDrag ? monitor.isOver() : false,
//         dropClassName:
//           dragIndex < index ? 'drop-over-downward' : 'drop-over-upward',
//       };
//     },
//     drop: (item: any) => {
//       if (canDrag) {
//         moveRow(item.index, index);
//       }
//     },
//   });

//   const [{ isDragging }, drag] = useDrag({
//     type: 'row',
//     item: { index },
//     canDrag: () => canDrag,
//     collect: (monitor) => ({
//       isDragging: canDrag ? monitor.isDragging() : false,
//     }),
//   });

//   drop(drag(ref));

//   return (
//     <tr
//       ref={ref}
//       className={`${className} ${isOver ? dropClassName : ''} ${
//         isDragging ? 'dragging' : ''
//       }`}
//       style={{ cursor: canDrag ? 'move' : 'default', ...style }}
//       {...restProps}
//     />
//   );
// };

const SizeList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [itemsPagination, setItemsPagintion] = useState<
    PaginationParamsResponse<IPrintArea>
  >({
    items: [],
    page: 1,
    perPage: PER_PAGE,
    total: 0,
    pageCount: 0,
  });

  // const moveRow = (dragIndex: number, hoverIndex: number) => {
  //   if (dragIndex === hoverIndex) return;

  //   const newData = [...itemsPagination.items];
  //   const dragItem = newData[dragIndex];

  //   // Remove the dragged item
  //   newData.splice(dragIndex, 1);
  //   // Insert at the new position
  //   newData.splice(hoverIndex, 0, dragItem);

  //   setItemsPagintion({
  //     ...itemsPagination,
  //     items: newData,
  //   });
  // };

  const columns: ColumnsType<IPrintArea> = [
    {
      title: 'Vùng in',
      key: 'id',
      render: (_, record) => (
        <Link to={`/print-area/${record.id}/edit`}>
          <p>{record.name}</p>
        </Link>
      ),
    },
    {
      title: 'Giá tiền',
      dataIndex: 'price',
      key: 'price',
      width: 200,
      render: (price: number) => <p>{price.toLocaleString('vi-VN')} VNĐ</p>,
    },
    {
      title: 'Mô tả',
      key: 'description',
      dataIndex: 'description',
    },
  ];

  useEffect(() => {
    const page = parseInt(getQueryParams().get('page') || '') || 1;
    const perPage = parseInt(getQueryParams().get('perPage') || '') || 15;
    loadData(page, perPage);
  }, [location]);

  const loadData = async (
    page = itemsPagination?.page,
    perPage = itemsPagination?.perPage
  ) => {
    try {
      const res = await orderApi.getPrintAreas({
        page,
        perPage,
      });

      setItemsPagintion(res);
    } catch (error) {
      setItemsPagintion({
        items: [],
        page,
        perPage,
        total: 0,
        pageCount: 0,
      });
      console.error(error);
    }
  };

  const onStateChanges = async (page: number, perPage: number) => {
    navigate(`${location.pathname}?page=${page}&perPage=${perPage}`, {
      replace: true,
    });
  };

  const onPageChange = (page: number, pageSize: number) => {
    onStateChanges(page, pageSize);
  };

  // Save the reordered items to backend
  // const saveReorderedItems = async () => {
  //   try {
  //     await orderApi.updateSizeOrder(
  //       itemsPagination.items.map((item, index) => ({
  //         ...item,
  //         numericalOrder: index + 1,
  //       }))
  //     );
  //     message.success('Size order saved successfully');
  //   } catch (error) {
  //     console.error('Failed to save new order:', error);
  //     message.error('Failed to save size order');
  //   }
  // };

  // Table components for drag and drop
  // const components = {
  //   body: {
  //     row: DraggableBodyRow,
  //   },
  // };

  // Need to use this workaround to fix TS errors
  // @ts-ignore
  // const processedProps = {
  //   className: 'm__t--20',
  //   columns: columns,
  //   dataSource: itemsPagination.items,
  //   pagination: {
  //     onChange: onPageChange,
  //     total: itemsPagination.total,
  //     pageSize: itemsPagination.perPage,
  //   },
  //   components: canReorder ? components : undefined,
  //   onRow: (record: any, index: any) => ({
  //     record,
  //     index,
  //     moveRow,
  //     canDrag: canReorder,
  //   }),
  //   rowKey: 'id',
  // };

  return (
    <DndProvider backend={HTML5Backend}>
      <PageContainer>
        <PageHeader
          title="Quản lý vùng in"
          addButton={
            <FlexContainer>
              {/* {canReorder && (
                <PrimaryButton
                  onClick={saveReorderedItems}
                  className="m__r--10"
                >
                  Save Order
                </PrimaryButton>
              )} */}
            </FlexContainer>
          }
        />

        {/* @ts-ignore */}
        <StyledTable columns={columns} dataSource={itemsPagination.items} />
      </PageContainer>
    </DndProvider>
  );
};
export default SizeList;
